var loadmoreButtons = document.querySelectorAll('.btn-loadmore');

loadmoreButtons.forEach(function(button) {
	button.addEventListener('click', function() {
		var maxNumPages = this.dataset.max_num_pages;
		var currentPage = document.querySelector('meta[name="current_page"]').getAttribute('content');

		var data = {
			'action': 'loadmore',
			'page': currentPage,
		};

		button.textContent = 'Chargement...';
		var btnWrap = button.closest('.btn-wrap');

		fetch('/wp-admin/admin-ajax.php', {
			method: 'POST',
			headers:{
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: new URLSearchParams(data)
		})
		.then(function(response) {
			if(response.ok) {
				return response.text();
			} else {
				throw new Error('Network response was not ok');
			}
		})
		.then(function(data) {
			if(data) {
				button.textContent = 'Afficher plus de témoignages';

				let loadmoreCont = document.getElementById('loadmore-cont');
				let parser = new DOMParser();
				let doc = parser.parseFromString(data, 'text/html');
				let divs = doc.querySelectorAll('div.single-card-review');
				divs.forEach(div => {
					loadmoreCont.appendChild(div);
				});

				fadeInElements(document.querySelectorAll('.review-ajax-loaded'), 2000);

				setInterval(function() {
					let reviewsAjaxLoaded = document.querySelectorAll('.review-ajax-loaded')
					reviewsAjaxLoaded.forEach(function(review) {
						review.classList.remove('review-ajax-loaded');
					});
				}, 1000);

				currentPage++;
				document.querySelector('meta[name="current_page"]').setAttribute('content', currentPage);

				if(currentPage == maxNumPages) {
					btnWrap.remove();
				}
			} else {
				btnWrap.remove();
			}
		})
		.catch(function(error) {
			btnWrap.remove();
		});
	});
});

function fadeInElements(elements, duration) {
	var increment = 100 / duration;
	var op = 0;
	var index = 0;

	function fadeInNextElement() {
		if(index < elements.length) {
			elements[index].style.opacity = op;
			if (op >= 1) {
				op = 0;
				index++;
			}
			op += increment;
			requestAnimationFrame(fadeInNextElement);
		}
	}

	requestAnimationFrame(fadeInNextElement);
}

var loadmoreRealisationsBtn = document.querySelectorAll('.btn-loadmore-realisations');
loadmoreRealisationsBtn.forEach(function(button) {
	button.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const maxPages = parseInt(this.dataset.realisationsPages);
		const currentPage = parseInt(this.dataset.realisationsCurrentPage);

		document.querySelectorAll('.realisations-'+currentPage).forEach(function(single) {
			single.style.display = 'block';
		});

		fadeInElements(document.querySelectorAll('.realisations-'+currentPage), 1500);

		this.dataset.realisationsCurrentPage = currentPage+1;

		if(currentPage == maxPages-1) {
			this.style.display = 'none';
		}
	});
});

var loadmoreProduitsBtn = document.querySelectorAll('.btn-loadmore-produits');
loadmoreProduitsBtn.forEach(function(button) {
	button.addEventListener('click', function(e) {
		e.preventDefault();
		e.stopPropagation();

		const produitsParPageMbl = parseInt(this.dataset.produitsMbl);
		const produitsParPageDsktp = parseInt(this.dataset.produitsDsktpPages);
		const maxMblPages = parseInt(this.dataset.produitsMblPages);
		const maxDsktpPages = parseInt(this.dataset.produitsDsktpPages);
		let currentMblPage = parseInt(this.dataset.produitsMblCurrentPage);
		let currentDsktpPage = parseInt(this.dataset.produitsDsktpCurrentPage);

		if(window.innerWidth < 768) {
			document.querySelectorAll('.produits-mbl-' + currentMblPage).forEach(function(single) {
				single.classList.remove('d-none', 'd-md-block');
			});

			currentMblPage++;
			this.dataset.produitsMblCurrentPage = currentMblPage;

			const totalProduitsAffiches = currentMblPage * produitsParPageMbl;
			const newDsktpPage = Math.ceil(totalProduitsAffiches / produitsParPageDsktp);
			this.dataset.produitsDsktpCurrentPage = newDsktpPage;

			if(currentMblPage >= maxMblPages) {
				this.classList.add('d-none');
			}
		} else {
			for(let page = 0; page <= currentDsktpPage; page++) {
				document.querySelectorAll('.produits-dsktp-' + page).forEach(function(single) {
					single.classList.remove('d-none', 'd-md-block');
				});
			}

			currentDsktpPage++;
			this.dataset.produitsDsktpCurrentPage = currentDsktpPage;

			const totalProduitsAffiches = currentDsktpPage * produitsParPageDsktp;
			const newMblPage = Math.ceil(totalProduitsAffiches / produitsParPageMbl);
			this.dataset.produitsMblCurrentPage = newMblPage;

			if(currentDsktpPage >= maxDsktpPages) {
				this.classList.add('d-md-none');
			}
		}
	});
});

var loadmoreNewsButtons = document.querySelectorAll('.btn-loadmore-news');
loadmoreNewsButtons.forEach(function(button) {
	button.addEventListener('click', function() {
		var maxNumPages	= this.dataset.max_num_pages;
		var currentPage	= document.querySelector('meta[name="current_page"]').getAttribute('content');
		var categorie	= this.dataset.categorie;

		var data = {
			'action': 'loadmore_news',
			'page': currentPage,
		};

		if(categorie) {
			data['categorie'] = categorie;
		}

		button.textContent = 'Chargement...';
		var btnWrap = button.closest('.btn-wrap');

		fetch('/wp-admin/admin-ajax.php', {
			method: 'POST',
			headers:{
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: new URLSearchParams(data)
		})
		.then(function(response) {
			if(response.ok) {
				return response.text();
			} else {
				throw new Error('Network response was not ok');
			}
		})
		.then(function(data) {
			if(data) {
				button.textContent = 'Afficher plus d\'actualités';

				let loadmoreCont = document.getElementById('loadmore-news-cont');
				let parser = new DOMParser();
				let doc = parser.parseFromString(data, 'text/html');
				let divs = doc.querySelectorAll('div.single-actualite');
				divs.forEach(div => {
					loadmoreCont.appendChild(div);
				});

				currentPage++;
				document.querySelector('meta[name="current_page"]').setAttribute('content', currentPage);
				
				if(currentPage == maxNumPages) {
					btnWrap.remove();
				}
			} else {
				btnWrap.remove();
			}
		})
		.catch(function(error) {
			btnWrap.remove();
		});
	});
});